import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';

import { ApiService } from 'src/app/core/services/api.service';
import { uriNormalize } from 'src/app/extensions/utilities';
import { FileEvents } from './events';

@Injectable()
export class FileStoreAPIService {
  constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  public getFile(fileName: string) {
    const url = `${uriNormalize(this._envConfig.FILE_MANAGER_API_URL)}/getFileBase64?filename=${fileName}`;
    const response = this._apiService.getRaw(url);
    return response;
  }

  public postFile(file: any) {
    const url = `${uriNormalize(this._envConfig.FILE_MANAGER_API_URL)}/postFiles`;
    const response = this._apiService.upload(url, file);
    return response;
  }

  public postFilesWithEvents(file: any) {
    const url = `${uriNormalize(this._envConfig.FILE_MANAGER_API_URL)}/postFilesWithEvents`;
    const response = this._apiService.upload<app.models.ServerResponseModel>(url, file);
    return response;
  }

  public deleteFile(documentId: string) {
    const url = `${uriNormalize(this._envConfig.FILE_MANAGER_API_URL)}/deleteFile`;
    const body = { documentId };
    const response = this._apiService.postAsync<app.models.ServerResponseModel>(url, body, [FileEvents.FileDeleted]);
    return response;
  }
}
